var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.787 17.452c-.283-.08-.578-.13-.845-.245-1.27-.546-1.956-1.857-1.7-3.227.02-.109-.01-.15-.093-.197-1.692-.962-3.383-1.924-5.072-2.891-.107-.062-.17-.055-.263.026-.886.777-2.147.936-3.198.41C.558 10.802-.096 9.683.011 8.515c.108-1.169.71-2.022 1.793-2.469 1.083-.446 2.103-.261 3.01.487.075.061.127.107.234.046 1.732-.993 3.468-1.981 5.189-2.962-.016-.292-.051-.574-.043-.855.042-1.356 1.118-2.54 2.463-2.728.044-.006.086-.022.13-.033h.613c.032.01.063.025.096.03 1.244.18 2.246 1.134 2.458 2.343.222 1.265-.37 2.498-1.49 3.1-1.109.597-2.469.407-3.388-.473-.04-.038-.081-.074-.127-.116L5.695 7.88c.168.575.161 1.134.002 1.695l5.282 3.01c.04-.054.069-.105.11-.143.687-.64 1.5-.903 2.427-.775 1.33.185 2.402 1.335 2.475 2.632.083 1.461-.792 2.699-2.162 3.057-.142.037-.286.065-.429.097h-.613z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialShareIcon);
export default __webpack_public_path__ + "static/media/social-share-icon.e6db2e9e.svg";
export { ForwardRef as ReactComponent };